export default __webpack_public_path__ + "static/media/minus.fb30694c.svg";